export default "__VITE_ASSET__C2bF9hJ5__"